<template>
    <v-dialog v-model="showDialog" width="600px">
        <!-- Host -->
        <v-card class="pa-4">
            <v-card-title class="pt-0 pb-2 justify-center">Potential Host Summary</v-card-title>  
            <v-divider></v-divider>
            <v-row cols="12" no-gutters>
                <v-col cols="4" class="pr-4">
                    Fist name
                </v-col>
                <v-col cols="8" class="pr-4" v-if="pten.pten_voornaam  !== ''">
                    {{ pten.pten_voornaam }}
                </v-col>
                <v-col cols="8" class="pr-4 fix-me-first" v-else>
                    Add fistname to lead before continuing
                </v-col>
            </v-row>
            <v-row cols="12" no-gutters>
                <v-col cols="4" class="pr-4">
                    Last name
                </v-col>
                <v-col cols="8" class="pr-4" v-if="pten.pten_naam !== ''">
                    {{ pten.pten_naam }}
                </v-col>
                <v-col cols="8" class="pr-4 fix-me-first" v-else>
                    Add last name to lead before continuing
                </v-col>
            </v-row>
            <v-row cols="12" no-gutters>
                <v-col cols="4" class="pr-4">
                    Language
                </v-col>
                <v-col cols="8" class="pr-4" v-if="pten.taal_code !== ''">
                    {{ pten.taal_code }}
                </v-col>
                <v-col cols="8" class="pr-4 fix-me-first" v-else>
                    Add language to lead before continuing
                </v-col>
            </v-row>
            <v-row cols="12" no-gutters>
                <v-col cols="4" class="pr-4">
                    Country
                </v-col>
                <v-col cols="8" class="pr-4" v-if="pten.land_code !== ''">
                    {{ pten.land_code }}
                </v-col>
                <v-col cols="8" class="pr-4 fix-me-first" v-else>
                    Add country to lead before continuing
                </v-col>
            </v-row>
            <v-divider></v-divider>
            <v-row cols="12" no-gutters>
                <v-col cols="12">
                    <v-checkbox v-model="merge" label="Merge with existing host"></v-checkbox>
                </v-col>
                <v-col cols="12" v-if="merge">
                    <v-autocomplete v-model="host_encrid" :items="hosts" item-text="description" item-value="value" label="Existing host" dense></v-autocomplete>
                </v-col>
            </v-row>
            <v-divider></v-divider>
            <v-card-actions class="pa-0 pt-2">
                <v-spacer></v-spacer>
                <v-btn class="primary mr-2" :disabled="!pten.complete" small @click="mergePtenToEign" v-if="merge">Merge host</v-btn>
                <v-btn class="primary mr-2" :disabled="!pten.complete" small @click="setPtenToEign" v-else>Make host</v-btn>
                <v-btn class="primary mr-2" small @click="closeDialog">Cancel</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

    export default {
        components: {
        },
        props: {
            pten_encrid: {
                type: String,
                required: true,
            },
        },
        data() {
            return {
                showDialog: false,
                merge: false,
                hosts: [],
                host_encrid: "",
                pten: {},
            };
        },
        methods: {
            openDialog() {
                this.showDialog = false;
                this.merge = false;
                this.host_encrid = "",
                this.hosts = [],
                this.pten = {},
                this.$axios.post("ares/json/ares/pten/getPtenToEign.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getPtenToEign",
                    },
                    getPtenToEign: {
                        pten_encrid: this.pten_encrid,
                    },
                }).then((res) => {
                    if (res.data.error) {
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.error.message,
                            color: "error",
                        });
                    } else {
                        this.pten = res.data.getPtenToEign;
                        this.hosts = res.data.hosts;                  
                        this.showDialog = true;
                    }
                });
            },
            mergePtenToEign() {
                if (this.host_encrid==="") {
                    this.$store.dispatch("setSnackbar", {
                        showing: true,
                        text: "Host to merge to must be set.",
                        color: "warning",
                    });
                    return;
                }

                this.$axios.post("ares/json/ares/pten/mergePtenToEign.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "mergePtenToEign",
                    },
                    mergePtenToEign: {
                        pten_encrid: this.pten.pten_encrid,
                        eign_encrid: this.host_encrid,
                    },
                }).then((res) => {
                    if (res.data.error) {
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.error.message,
                            color: "error",
                        });
                    } else {
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.mergePtenToEign.text,
                            color: res.data.mergePtenToEign.color,
                        });
                        this.$router.reload('/eign/onEign/' + res.data.mergePtenToEign.eign_encrid);
                    }
                });
            },
            setPtenToEign() {
                // alert("setPtenToEign");
                this.$axios.post("ares/json/ares/pten/savePtenToEign.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "savePtenToEign",
                    },
                    savePtenToEign: {
                        pten_encrid: this.pten.pten_encrid,
                    },
                }).then((res) => {
                    if (res.data.error) {
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.error.message,
                            color: "error",
                        });
                    } else {
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.savePtenToEign.text,
                            color: res.data.savePtenToEign.color,
                        });
                        this.$router.reload('/eign/onEign/' + res.data.savePtenToEign.eign_encrid);
                    }
                });
            },
            closeDialog() {
                this.showDialog = false;
            },
        },
    };
</script>

<style scoped>
    .fix-me-first {
        color: red;
    }
</style>